import { Link, useLocation } from "react-router-dom";
import Logo from "@/components/Logo";

export default function Footer() {
  const loc = useLocation();
  if (loc.pathname.startsWith("/broker/respond")) return null;
  return (
    <footer className="border-t border-gray-200 bg-white mt-24">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-12 grid md:grid-cols-4 gap-8 text-sm">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2.5">
            <Logo size={28} />
            <div className="font-display font-bold text-lg text-gray-900">
              borra-me<span className="text-[#DC2626]">.</span>com
            </div>
          </div>
          <p className="text-gray-600 mt-3 max-w-md">Eliminamos tus datos personales de los rutificadores y brokers chilenos usando el derecho ARCOP (Ley 21.719).</p>
          <p className="font-mono text-xs text-gray-500 mt-4">© {new Date().getFullYear()} borra-me.com SpA · Santiago, Chile</p>
        </div>
        <div>
          <div className="eyebrow mb-3">Producto</div>
          <ul className="space-y-2 text-gray-700">
            <li><Link to="/#precio">Precios</Link></li>
            <li><Link to="/blog">Blog</Link></li>
            <li><Link to="/#faq">Preguntas frecuentes</Link></li>
          </ul>
        </div>
        <div>
          <div className="eyebrow mb-3">Legal</div>
          <ul className="space-y-2 text-gray-700">
            <li><a href="https://leydedatoschile.com" target="_blank" rel="noreferrer">Ley 21.719 ↗</a></li>
            <li><Link to="/legal/terminos">Términos</Link></li>
            <li><Link to="/legal/privacidad">Privacidad</Link></li>
            <li><Link to="/legal/cookies">Cookies</Link></li>
          </ul>
        </div>
      </div>
    </footer>
  );
}
